import {
  Component,
  DOCUMENT,
  Renderer2,
  inject,
  isDevMode,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../config/environment';
import { OnyxSplashScreenComponent } from '@onyx/angular';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, OnyxSplashScreenComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);

  constructor() {
    this.injectPreconnectLink();
    this.injectGoogleAnalytics();
    this.injectContentsquare();
  }

  private injectPreconnectLink(): void {
    if (isDevMode()) return;

    const preconnectLink = this.renderer.createElement('link');
    this.renderer.setAttribute(preconnectLink, 'rel', 'preconnect');
    this.renderer.setAttribute(preconnectLink, 'href', environment.frontendUrl);
    this.renderer.appendChild(this.document.head, preconnectLink);
  }

  private injectGoogleAnalytics(): void {
    if (environment.type !== 'production' || isDevMode()) return;

    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'async', '');
    this.renderer.setAttribute(
      script,
      'src',
      'https://www.googletagmanager.com/gtag/js?id=G-JBSG0VK21T',
    );
    this.renderer.appendChild(this.document.head, script);

    const inlineScript = this.renderer.createElement('script');
    inlineScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments)};
      gtag('js', new Date());
      gtag('config', 'G-JBSG0VK21T');
    `;
    this.renderer.appendChild(this.document.head, inlineScript);
  }

  private injectContentsquare(): void {
    if (environment.type !== 'production' || isDevMode()) return;

    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(
      script,
      'src',
      'https://t.contentsquare.net/uxa/f2fd88ea0b619.js',
    );
    this.renderer.setAttribute(script, 'defer', '');
    this.renderer.appendChild(this.document.head, script);
  }
}
